import { assign, cloneDeep, find, concat } from 'lodash';
import { removeArrayItemsFromNestedListByID } from 'utils/array';

import * as KEYS from 'constants/keys';
import * as api from 'api/api-invitations';

import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  search: false,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
  meta: {},
  data: [],
};

const neutralState = {
  fetching: false,
  fetched: true,
  search: false,
  saving: false,
  empty: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  InvitationsList: state => state,
};

const actions = {
  GetInvitationsList({ commit }, params) {
    const query = params.query;

    console.log('GetInvitationsList', params);

    commit(types.FETCH_INVITATIONS_LIST_START);
    api.getInvitations(
      query,
      (response) => {
        commit(types.RECEIVE_INVITATIONS_LIST, { response });
      },
      (description, status, error) => {
        commit(types.FETCH_INVITATIONS_LIST_ERROR, { error });
      },
    );
  },
  AddInvitationToInvitationsList({ commit }, response) {
    return new Promise((resolve) => {
      const data = cloneDeep(response.data);
      commit(types.ADD_INVITATION_TO_INVITATIONS_LIST, { data });
      resolve(true);
    });
  },
  UpdateInvitationInInvitationsList({ commit }, response) {
    return new Promise((resolve) => {
      const data = cloneDeep(response.data);
      commit(types.UPDATE_INVITATION_IN_INVITATIONS_LIST, { data });
      resolve(true);
    });
  },
  RemoveInvitationFromInvitationsList({ commit }, id) {
    return new Promise((resolve) => {
      commit(types.REMOVE_INVITATION_FROM_INVITATIONS_LIST, { id });
      resolve(true);
    });
  },
  ClearInvitationsList({ commit }) {
    console.log('ClearInvitationsList');
    commit(types.CLEAR_INVITATIONS_LIST_STORE);
  },
};

const mutations = {
  [types.FETCH_INVITATIONS_LIST_START](state) {
    assign(state, neutralState, { fetching: true });
  },
  [types.FETCH_INVITATIONS_LIST_ERROR](state, { error }) {
    assign(state, neutralState, { error });
  },
  [types.RECEIVE_INVITATIONS_LIST](state, { response }) {
    assign(state, neutralState, { ready: true, meta: response.meta, data: response.data });
  },

  [types.CLEAR_INVITATIONS_LIST_STORE](state) {
    assign(state, initState);
  },

  [types.ADD_INVITATION_TO_INVITATIONS_LIST](state, { data }) {
    const recentlyModifiedList = find(state.data, item => item.code === KEYS.RECENTLY_MODIFIED);
    if (recentlyModifiedList) recentlyModifiedList.items = concat(data, recentlyModifiedList.items);
  },

  [types.UPDATE_INVITATION_IN_INVITATIONS_LIST](state, { data }) {
    console.log('UPDATE_INVITATION_IN_INVITATIONS_LIST', data);
    removeArrayItemsFromNestedListByID(state.data, data.id);
    const recentlyModifiedList = find(state.data, item => item.code === KEYS.RECENTLY_MODIFIED);
    if (recentlyModifiedList) recentlyModifiedList.items = concat(data, recentlyModifiedList.items);
  },

  [types.REMOVE_INVITATION_FROM_INVITATIONS_LIST](state, { id }) {
    console.log('REMOVE_INVITATION_FROM_INVITATIONS_LIST', id);
    removeArrayItemsFromNestedListByID(state.data, id);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/invitations/entities/invitations-list.js